/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BusinessReportRowDTO interface.
 */
export function instanceOfBusinessReportRowDTO(value) {
    return true;
}
export function BusinessReportRowDTOFromJSON(json) {
    return BusinessReportRowDTOFromJSONTyped(json, false);
}
export function BusinessReportRowDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'inventoryId': json['inventoryId'] == null ? undefined : json['inventoryId'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'sku': json['sku'] == null ? undefined : json['sku'],
        'title': json['title'] == null ? undefined : json['title'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'inReport': json['inReport'] == null ? undefined : json['inReport'],
        'salesCurrency': json['salesCurrency'] == null ? undefined : json['salesCurrency'],
        'unitsOrdered': json['unitsOrdered'] == null ? undefined : json['unitsOrdered'],
        'unitsOrderedB2b': json['unitsOrderedB2b'] == null ? undefined : json['unitsOrderedB2b'],
        'orderedProductSales': json['orderedProductSales'] == null ? undefined : json['orderedProductSales'],
        'orderedProductSalesB2b': json['orderedProductSalesB2b'] == null ? undefined : json['orderedProductSalesB2b'],
        'totalOrderItems': json['totalOrderItems'] == null ? undefined : json['totalOrderItems'],
        'totalOrderItemsB2b': json['totalOrderItemsB2b'] == null ? undefined : json['totalOrderItemsB2b'],
        'browserSessions': json['browserSessions'] == null ? undefined : json['browserSessions'],
        'browserSessionsB2b': json['browserSessionsB2b'] == null ? undefined : json['browserSessionsB2b'],
        'mobileAppSessions': json['mobileAppSessions'] == null ? undefined : json['mobileAppSessions'],
        'mobileAppSessionsB2b': json['mobileAppSessionsB2b'] == null ? undefined : json['mobileAppSessionsB2b'],
        'sessions': json['sessions'] == null ? undefined : json['sessions'],
        'sessionsB2b': json['sessionsB2b'] == null ? undefined : json['sessionsB2b'],
        'browserPageViews': json['browserPageViews'] == null ? undefined : json['browserPageViews'],
        'browserPageViewsB2b': json['browserPageViewsB2b'] == null ? undefined : json['browserPageViewsB2b'],
        'mobileAppPageViews': json['mobileAppPageViews'] == null ? undefined : json['mobileAppPageViews'],
        'mobileAppPageViewsB2b': json['mobileAppPageViewsB2b'] == null ? undefined : json['mobileAppPageViewsB2b'],
        'pageViews': json['pageViews'] == null ? undefined : json['pageViews'],
        'pageViewsB2b': json['pageViewsB2b'] == null ? undefined : json['pageViewsB2b'],
        'browserSessionPercentage': json['browserSessionPercentage'] == null ? undefined : json['browserSessionPercentage'],
        'browserSessionPercentageB2b': json['browserSessionPercentageB2b'] == null ? undefined : json['browserSessionPercentageB2b'],
        'mobileAppSessionPercentage': json['mobileAppSessionPercentage'] == null ? undefined : json['mobileAppSessionPercentage'],
        'mobileAppSessionPercentageB2b': json['mobileAppSessionPercentageB2b'] == null ? undefined : json['mobileAppSessionPercentageB2b'],
        'sessionPercentage': json['sessionPercentage'] == null ? undefined : json['sessionPercentage'],
        'sessionPercentageB2b': json['sessionPercentageB2b'] == null ? undefined : json['sessionPercentageB2b'],
        'browserPageViewsPercentage': json['browserPageViewsPercentage'] == null ? undefined : json['browserPageViewsPercentage'],
        'browserPageViewsPercentageB2b': json['browserPageViewsPercentageB2b'] == null ? undefined : json['browserPageViewsPercentageB2b'],
        'mobileAppPageViewsPercentage': json['mobileAppPageViewsPercentage'] == null ? undefined : json['mobileAppPageViewsPercentage'],
        'mobileAppPageViewsPercentageB2b': json['mobileAppPageViewsPercentageB2b'] == null ? undefined : json['mobileAppPageViewsPercentageB2b'],
        'pageViewsPercentage': json['pageViewsPercentage'] == null ? undefined : json['pageViewsPercentage'],
        'pageViewsPercentageB2b': json['pageViewsPercentageB2b'] == null ? undefined : json['pageViewsPercentageB2b'],
        'buyBoxPercentage': json['buyBoxPercentage'] == null ? undefined : json['buyBoxPercentage'],
        'buyBoxPercentageB2b': json['buyBoxPercentageB2b'] == null ? undefined : json['buyBoxPercentageB2b'],
        'unitSessionPercentage': json['unitSessionPercentage'] == null ? undefined : json['unitSessionPercentage'],
        'unitSessionPercentageB2b': json['unitSessionPercentageB2b'] == null ? undefined : json['unitSessionPercentageB2b'],
    };
}
export function BusinessReportRowDTOToJSON(json) {
    return BusinessReportRowDTOToJSONTyped(json, false);
}
export function BusinessReportRowDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'inventoryId': value['inventoryId'],
        'asin': value['asin'],
        'sku': value['sku'],
        'title': value['title'],
        'imageUrl': value['imageUrl'],
        'inReport': value['inReport'],
        'salesCurrency': value['salesCurrency'],
        'unitsOrdered': value['unitsOrdered'],
        'unitsOrderedB2b': value['unitsOrderedB2b'],
        'orderedProductSales': value['orderedProductSales'],
        'orderedProductSalesB2b': value['orderedProductSalesB2b'],
        'totalOrderItems': value['totalOrderItems'],
        'totalOrderItemsB2b': value['totalOrderItemsB2b'],
        'browserSessions': value['browserSessions'],
        'browserSessionsB2b': value['browserSessionsB2b'],
        'mobileAppSessions': value['mobileAppSessions'],
        'mobileAppSessionsB2b': value['mobileAppSessionsB2b'],
        'sessions': value['sessions'],
        'sessionsB2b': value['sessionsB2b'],
        'browserPageViews': value['browserPageViews'],
        'browserPageViewsB2b': value['browserPageViewsB2b'],
        'mobileAppPageViews': value['mobileAppPageViews'],
        'mobileAppPageViewsB2b': value['mobileAppPageViewsB2b'],
        'pageViews': value['pageViews'],
        'pageViewsB2b': value['pageViewsB2b'],
        'browserSessionPercentage': value['browserSessionPercentage'],
        'browserSessionPercentageB2b': value['browserSessionPercentageB2b'],
        'mobileAppSessionPercentage': value['mobileAppSessionPercentage'],
        'mobileAppSessionPercentageB2b': value['mobileAppSessionPercentageB2b'],
        'sessionPercentage': value['sessionPercentage'],
        'sessionPercentageB2b': value['sessionPercentageB2b'],
        'browserPageViewsPercentage': value['browserPageViewsPercentage'],
        'browserPageViewsPercentageB2b': value['browserPageViewsPercentageB2b'],
        'mobileAppPageViewsPercentage': value['mobileAppPageViewsPercentage'],
        'mobileAppPageViewsPercentageB2b': value['mobileAppPageViewsPercentageB2b'],
        'pageViewsPercentage': value['pageViewsPercentage'],
        'pageViewsPercentageB2b': value['pageViewsPercentageB2b'],
        'buyBoxPercentage': value['buyBoxPercentage'],
        'buyBoxPercentageB2b': value['buyBoxPercentageB2b'],
        'unitSessionPercentage': value['unitSessionPercentage'],
        'unitSessionPercentageB2b': value['unitSessionPercentageB2b'],
    };
}
